/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createMediaItem } from "../graphql/mutations";
const client = generateClient();
export default function MediaItemCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    carrierId: "",
    category: "",
    drmCount: "",
    minCount: "",
    maxCount: "",
    isActive: false,
  };
  const [carrierId, setCarrierId] = React.useState(initialValues.carrierId);
  const [category, setCategory] = React.useState(initialValues.category);
  const [drmCount, setDrmCount] = React.useState(initialValues.drmCount);
  const [minCount, setMinCount] = React.useState(initialValues.minCount);
  const [maxCount, setMaxCount] = React.useState(initialValues.maxCount);
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setCarrierId(initialValues.carrierId);
    setCategory(initialValues.category);
    setDrmCount(initialValues.drmCount);
    setMinCount(initialValues.minCount);
    setMaxCount(initialValues.maxCount);
    setIsActive(initialValues.isActive);
    setErrors({});
  };
  const validations = {
    carrierId: [{ type: "Required" }],
    category: [{ type: "Required" }],
    drmCount: [],
    minCount: [],
    maxCount: [],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          carrierId,
          category,
          drmCount,
          minCount,
          maxCount,
          isActive,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createMediaItem.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "MediaItemCreateForm")}
      {...rest}
    >
      <TextField
        label="Carrier id"
        isRequired={true}
        isReadOnly={false}
        value={carrierId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierId: value,
              category,
              drmCount,
              minCount,
              maxCount,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.carrierId ?? value;
          }
          if (errors.carrierId?.hasError) {
            runValidationTasks("carrierId", value);
          }
          setCarrierId(value);
        }}
        onBlur={() => runValidationTasks("carrierId", carrierId)}
        errorMessage={errors.carrierId?.errorMessage}
        hasError={errors.carrierId?.hasError}
        {...getOverrideProps(overrides, "carrierId")}
      ></TextField>
      <TextField
        label="Category"
        isRequired={true}
        isReadOnly={false}
        value={category}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierId,
              category: value,
              drmCount,
              minCount,
              maxCount,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.category ?? value;
          }
          if (errors.category?.hasError) {
            runValidationTasks("category", value);
          }
          setCategory(value);
        }}
        onBlur={() => runValidationTasks("category", category)}
        errorMessage={errors.category?.errorMessage}
        hasError={errors.category?.hasError}
        {...getOverrideProps(overrides, "category")}
      ></TextField>
      <TextField
        label="Drm count"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={drmCount}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              carrierId,
              category,
              drmCount: value,
              minCount,
              maxCount,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.drmCount ?? value;
          }
          if (errors.drmCount?.hasError) {
            runValidationTasks("drmCount", value);
          }
          setDrmCount(value);
        }}
        onBlur={() => runValidationTasks("drmCount", drmCount)}
        errorMessage={errors.drmCount?.errorMessage}
        hasError={errors.drmCount?.hasError}
        {...getOverrideProps(overrides, "drmCount")}
      ></TextField>
      <TextField
        label="Min count"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={minCount}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              carrierId,
              category,
              drmCount,
              minCount: value,
              maxCount,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.minCount ?? value;
          }
          if (errors.minCount?.hasError) {
            runValidationTasks("minCount", value);
          }
          setMinCount(value);
        }}
        onBlur={() => runValidationTasks("minCount", minCount)}
        errorMessage={errors.minCount?.errorMessage}
        hasError={errors.minCount?.hasError}
        {...getOverrideProps(overrides, "minCount")}
      ></TextField>
      <TextField
        label="Max count"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={maxCount}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              carrierId,
              category,
              drmCount,
              minCount,
              maxCount: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.maxCount ?? value;
          }
          if (errors.maxCount?.hasError) {
            runValidationTasks("maxCount", value);
          }
          setMaxCount(value);
        }}
        onBlur={() => runValidationTasks("maxCount", maxCount)}
        errorMessage={errors.maxCount?.errorMessage}
        hasError={errors.maxCount?.hasError}
        {...getOverrideProps(overrides, "maxCount")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              carrierId,
              category,
              drmCount,
              minCount,
              maxCount,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
